<template>
    <div id="app"><transition name="full-fade"><router-view></router-view></transition></div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      msg: 'Welcome to My Vue.js App'
    }
  }
}
</script>

<style lang="scss">
body {
  margin: 0;
  height: 100vh;
  background-color: #f1f4f6;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.full-fade-enter-active, .full-fade-leave-active {
  transition: opacity 1s;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%
}
.full-fade-enter, .full-fade-leave-to {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue